export default function educationAppendContent() {
  return function link($scope, $element, $attrs) {
    $scope.$watch($attrs.educationAppendContent, (contentElement) => {
      $element.empty();
      $element.append(contentElement);
    });
  };
}
